import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { FIRM, NAV_LINKS } from "../data/mock";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ivory/95 backdrop-blur-md border-b border-[#C0974E]/15 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <a
          href="/"
          data-testid="header-logo"
          className="flex items-center group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_legal-finance-3/artifacts/jf349uv5_logo-1.png"
            alt="The Bufkin Law Firm"
            className={`transition-all duration-500 ${
              scrolled ? "h-10 md:h-11" : "h-12 md:h-14"
            } w-auto`}
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm tracking-wide text-navy/80 hover:text-navy link-underline transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Phone CTA */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${FIRM.phone.replace(/[^\d+]/g, "")}`}
            data-testid="header-phone"
            className="flex items-center gap-2 text-sm text-navy font-medium hover:text-gold transition-colors"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={2} />
            {FIRM.phone}
          </a>
          <a
            href="/#contact"
            data-testid="header-cta"
            className="btn-primary px-5 py-2.5 text-xs tracking-[0.2em] uppercase font-medium"
          >
            Consultation
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-navy"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden absolute top-full left-0 right-0 bg-ivory border-t border-[#C0974E]/20 py-6 px-6 shadow-lg"
        >
          <nav className="flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-base text-navy py-2 border-b border-[#C0974E]/10"
              >
                {link.label}
              </a>
            ))}
            <a
              href={`tel:${FIRM.phone.replace(/[^\d+]/g, "")}`}
              className="flex items-center gap-2 text-base text-navy font-medium mt-2"
            >
              <Phone className="w-4 h-4" /> {FIRM.phone}
            </a>
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta"
              className="btn-primary px-5 py-3 text-xs tracking-[0.2em] uppercase font-medium text-center mt-2"
            >
              Schedule Consultation
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
